// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"_1uLzpATR","inline":"_1bq027mu","loader":"_119Zrrvq","dot":"dOaRClsv","dot1":"W1pCMu_d","dot-jump":"Tc8j2qoB","dot2":"iDks_33f","dot3":"_2BHm8cg4"};